import React, { ComponentProps } from 'react';
import { ProfileImage } from '../../../types/api/ImageType';
import { asView, useFetchUrl } from '../../../_lib/ViewFetcher';
import { Image, ImageModifier } from '../../../components/molecules/Image';

type PortalLogoDefaultProps = {
  image: ProfileImage;
};
export function PortalLogoDefault({ image }: PortalLogoDefaultProps) {
  const fetchUrl = useFetchUrl();
  return <Image key={image.src} image={image} fetchUrl={fetchUrl} modifier={ImageModifier.WIDTH_AUTO} />;
}
export const PortalLogoDefaultView = asView(PortalLogoDefault);
export type PortalLogoDefaultView = ComponentProps<typeof PortalLogoDefaultView>;
